import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import get from '../../utils/get';
import { createImageProxyTemplate, formatImageProxyUrl } from '../../utils/svtimage';
import AccessibilityLinks from '../AccessibilityLinks/AccessibilityLinks';
import PlayButton from '../PlayButton/PlayButton';
import { GridItem, GridWrapper, Heading, LinkToAll } from './PromotionGrid.styles';

const PromotionGrid = ({
    title,
    mainGenres,
    showAccessibilityLinks = false,
    onItemClick,
    withDivider,
    className,
}) => {
    const classes = classNames(className, 'lp_clust');

    return (
        <GridWrapper className={classes} aria-label="Genrer" withDivider={withDivider}>
            {title && <Heading>{title}</Heading>}
            <AccessibilityLinks isVisible={showAccessibilityLinks} />
            {mainGenres.map((item, i) => {
                const promoItem = {
                    urlPart: `/genre/${item.id}`,
                    posterImageUrl: item.image
                        ? formatImageProxyUrl(
                              createImageProxyTemplate(item.image.id, item.image.changed),
                              'medium',
                              480
                          )
                        : '',
                    posterAltText: get(item, 'image.description', ''),
                    name: item.name,
                };

                return <GridItem item={promoItem} key={i} index={i + 1} expanded />;
            })}
            <LinkToAll data-rt="promotion-item">
                <PlayButton isCentered to="/genre" onAfterClick={(e) => onItemClick('alla')}>
                    Visa alla genrer <span className="play_bumping-arrow-icon" aria-hidden="true" />
                </PlayButton>
            </LinkToAll>
        </GridWrapper>
    );
};

PromotionGrid.propTypes = {
    title: PropTypes.string,
    mainGenres: PropTypes.arrayOf(PropTypes.object).isRequired,
    showAccessibilityLinks: PropTypes.bool,
    onItemClick: PropTypes.func,
};

export default PromotionGrid;
